import { render, staticRenderFns } from "./StoriesCard.vue?vue&type=template&id=bb652b9e&scoped=true"
import script from "./StoriesCard.vue?vue&type=script&lang=ts"
export * from "./StoriesCard.vue?vue&type=script&lang=ts"
import style0 from "./StoriesCard.vue?vue&type=style&index=0&id=bb652b9e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb652b9e",
  null
  
)

export default component.exports